export default {
  errorDefault: 'Wystąpił błąd',
  unknown: 'Nieznany',
};
